import {
	mapGetters,
	mapActions
} from 'vuex';

import {
	isEmpty,
	isInteger,
	cloneDeep
} from 'lodash';

import moment from 'moment';

import PageBar from '@/components/page-bar/page-bar';

import toastr from '@/support/toastr';

import RecipientsGroup from '@/domains/school/recipients-group/main';
import ClassLevel from '@/domains/school/class-level/main';
import ClassGrade from '@/domains/school/class-grade/main';
import SchoolClass from '@/domains/school/class-list/main';

import Year from '@/components/calendar/year/main';
import Month from '@/components/calendar/month/main';
import Week from '@/components/calendar/week/main';

import {
	EventBus
} from '@/support/event-bus';

export default {
	name: 'meal-menu-clone',
	data: () => ({
		recipientGroup: '',
		year: '',
		month: '',
		week: '',
		level: '',
		grade: '',
		schoolClass: '',
		mealMenuClone: [],
		params: {}
	}),
	components: {
		PageBar,
		RecipientsGroup,
		ClassLevel,
		ClassGrade,
		SchoolClass,
		Year,
		Month,
		Week
	},
	computed: {
		...mapGetters([
			'ENUM',
			'getLoggedUser',
			'currentYear',
			'currentMonth',
			'currentWeek',
			'classLevel',
			'classGrade',
			'mealMenu',
			'getClass'
		])
	},
	methods: {
		...mapActions([
			'setBreadcrumb',
			'getMealMenu',
			'putMealMenu',
			'updateMealMenu',
			'putCurrentMonth',
			'putCurrentWeek',
			'putWeekList'
		]),
		formIsValid() {

			return !isEmpty(this.recipientGroup) &&
				isInteger(this.year) &&
				!isEmpty(this.month) &&
				!isEmpty(this.week);

		},
		updateState(data) {
			return this.updateMealMenu(data);
		},
		updateMonth() {

			this.month = '';
			this.putCurrentMonth({});

			EventBus.$emit('updateWeekList', {
				year: this.year,
				month: this.month
			});

		},
		updateWeek() {

			this.week = '';
			this.putCurrentWeek({});

			EventBus.$emit('updateWeekList', {
				year: this.year,
				month: this.month
			});

		},
		getSchoolMealMenu(filter) {

			if (filter.year && filter.month && filter.startDate && filter.endDate) {

				const queryFilter = {
					startDate: filter.startDate,
					endDate: filter.endDate
				};

				if (filter.recipientGroup === 'PER_LEVEL') {
					queryFilter.level = this.classLevel;
				}

				if (filter.recipientGroup === 'PER_GRADE') {

					queryFilter.level = this.classGrade.level;
					queryFilter.gradeId = this.classGrade.gradeId;

				}

				if (filter.recipientGroup === 'PER_CLASS') {

					queryFilter.level = this.getClass.schoolClassLevel;
					queryFilter.gradeId = this.getClass.schoolClassGrade.gradeId;
					queryFilter.schoolClassId = this.getClass.schoolClassId;

				}

				return this.getMealMenu({
					userId: this.getLoggedUser.id,
					filter: queryFilter
				}).then(() => {

					this.mealMenuClone = cloneDeep(this.mealMenu).map((value) => {

						value.clonedDate = value.date;
						value.date = null;

						delete value.id;

						return value;

					});

				});

			}

		},
		addItem(index) {

			this.mealMenuClone[index].times.push({
				beverage: '',
				meal: '',
				time: '',
				type: ''
			});

			this.updateState(cloneDeep(this.mealMenuClone));

		},
		removeItem(mealIndex, timesIndex) {

			this.mealMenuClone[mealIndex].times.splice(timesIndex, 1);

			this.updateState(cloneDeep(this.mealMenuClone));

		},
		removeMealDay(index) {

			this.mealMenuClone[index].times = [];

		},
		save() {

			if (this.formIsValid()) {

				this.updateState(cloneDeep(this.mealMenuClone));

				const payload = cloneDeep(this.mealMenu).map((value) => {

					this.startDate = this.currentWeek.startDate;
					this.endDate = this.currentWeek.endDate;

					if (this.recipientGroup === 'PER_LEVEL') {
						value.level = this.classLevel;
					}

					if (this.recipientGroup === 'PER_GRADE') {

						value.grade = {
							level: this.classGrade.level,
							gradeId: this.classGrade.gradeId
						};

					}

					if (this.recipientGroup === 'PER_CLASS') {

						value.schoolClass = {
							level: this.getClass.schoolClassId,
							gradeId: this.getClass.schoolClassId,
							schoolClassId: this.getClass.schoolClassId
						};

					}

					if (value.id) {
						delete value.id;
					}

					value.times = value.times.map((time) => {

						if (time.time && time.time.length === 5) {
							time.time = `${ time.time }:00`;
						} else {
							time.time = null;
						}

						return time;

					});

					return value;

				});

				this.putMealMenu({
					userId: this.getLoggedUser.id,
					data: payload
				}).then(() => {

					toastr.success(this.$gettext('Cardápio duplicado com sucesso!'));

					const query = {};

					query.startDate = this.currentWeek.startDate;
					query.endDate = this.currentWeek.endDate;
					query.recipientGroup = this.recipientGroup;

					if (this.recipientGroup === 'PER_LEVEL') {
						query.level = this.classLevel;
					}

					if (this.recipientGroup === 'PER_GRADE') {

						query.grade = {
							level: this.classGrade.level,
							gradeId: this.classGrade.gradeId
						};

					}

					if (this.recipientGroup === 'PER_CLASS') {

						query.schoolClass = JSON.stringify({
							level: this.getClass.schoolClassId,
							gradeId: this.getClass.schoolClassId,
							schoolClassId: this.getClass.schoolClassId
						});

					}

					this.$router.push({
						name: 'MealMenu',
						query
					});

				});

			}

		},
		dateDiff(input, value = moment(), units = 'days') {
			return moment(value).diff(input, units);
		}
	},
	created() {

		this.setBreadcrumb([{
			text: this.$gettext('Administrativo')
		}, {
			text: this.$gettext('Cardápio')
		}, {
			text: this.$gettext('Duplicar')
		}]);

		this.params = this.$route.params;
		EventBus.$emit('classLevelSelected', this.classLevel);

		if (isEmpty(this.params)) {

			this.$router.push({
				name: 'MealMenu'
			});

		}

		this.getSchoolMealMenu(this.params);
		this.recipientGroup = this.params.recipientGroup;

		this.year = this.params.year;
		this.month = this.params.month;

	},
	mounted() {

		EventBus.$on('recipientGroupSelected', (payload) => {
			this.recipientGroup = payload;
		});

		EventBus.$on('classLevelSelected', () => {
			this.updateWeek();
		});

		EventBus.$on('classGradeSelected', () => {
			this.updateWeek();
		});

		EventBus.$on('classChanged', () => {
			this.updateWeek();
		});

		EventBus.$on('yearChanged', (payload) => {

			this.year = payload;

			this.updateMonth();
			this.updateWeek();

		});

		EventBus.$on('monthChanged', (payload) => {

			this.month = payload;

			this.updateWeek();

		});

		EventBus.$on('weekChanged', (payload) => {

			let initialDate = moment(payload.startDate);

			this.week = payload;

			this.mealMenuClone.map((value) => {

				value.date = cloneDeep(initialDate).format('YYYY-MM-DD');
				value.isBefore = cloneDeep(initialDate).add(1, 'day').isBefore();

				initialDate.add(1, 'd');

				return value;

			});

		});

	},
	beforeDestroy() {

		EventBus.$off('recipientGroupSelected');
		EventBus.$off('classLevelSelected');
		EventBus.$off('classGradeSelected');
		EventBus.$off('classChanged');
		EventBus.$off('yearChanged');
		EventBus.$off('monthChanged');
		EventBus.$off('weekChanged');

	}
};


// WEBPACK FOOTER //
// ./sources/app/meal-menu/clone/index.js